/**
 * /tenants/$slug/entitlement — the platform's contract with this tenant, per
 * product area. Reached from the platform Tenants list, never from inside
 * the tenant's Settings: the write is a provider record with
 * its own audit scope, and mixing it into the tenant's roster confuses who
 * decided what. Guarded by product_areas.census, a platform-scope permission.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

// Preserve saved links while keeping platform subscriptions outside tenant scope.
export const Route = createFileRoute("/_authed/tenants/$slug/entitlement")({
  beforeLoad: ({ params }) => { throw redirect({ to: "/tenant-records/$slug/subscription", params, replace: true }); },
});
